import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import axiosObj from './config';
import { handleQuery } from '../utils/request';


const RELEASE_API_URL = `${process.env.API_URL}/release/graphql`;

const BULK_ACTION = {
  message: true,
  skippedCount: true,
};

const RELEASE_RETURN_VALUES = {
  id: true,
  name: true,
  createdBy: {
    id: true,
    name: true,
  },
  profile: {
    id: true,
    name: true,
  },
  workspaceId: true,
  releaseBuiild: {
    status: true,
    currentPhase: true,
    id: true,
    phases: {
      durationInSeconds: true,
      phaseType: true,
      phaseStatus: true,
    },

  },
  createdAt: true,
  updatedAt: true,
};

const PROFILE_RETURN_VALUES = {
  id: true,
  tags: true,
  description: true,
  application: {
    id: true,
    name: true,
  },
  applicationVersion: true,
  deviceCount: true,
  deployedDeviceCount: true,
  assignedDeviceCount: true,
  errorDeviceCount: true,
  name: true,
  createdBy: {
    id: true,
    name: true,
  },
  createdAt: true,
  updatedAt: true,
  archived: true,
};

const PROFILES_RETURN_VALUES = {
  id: true,
  tags: true,
  description: true,
  deviceCount: true,
  application: {
    id: true,
    name: true,
  },
  applicationVersion: true,
  name: true,
  createdAt: true,
  createdBy: {
    id: true,
    name: true,
  },
  updatedAt: true,
  archived: true,
  demoData: true,
};

const PROFILE_VERSION_RETURN_VALUES = {
  id: true,
  tags: true,
  description: true,
  version: true,
  name: true,
  createdBy: {
    id: true,
    name: true,
  },
  updatedBy: {
    id: true,
    name: true,
  },
  updatedAt: true,
};

export function getProfileTags(args) {
  const query = {
    query: {
      profileTags: {
        __args: args
      }
    }
  }
  return handleQuery(query, RELEASE_API_URL)
}

export function updateProfileTags(args) {
  const query = {
    mutation: {
      bulkUpdateProfileTags: {
        __args: args,
      },
    },
  }
  return handleQuery(query, RELEASE_API_URL)
}

export function assignProfile(param) {
  let query = '';
  // if (param.devices.length > 1) {
  query = {
    mutation: {
      assignProfileToDevices: {
        __args: {
          devices: param.devices,
          profileId: param.profileId,
        },
        ...BULK_ACTION,
      },
    },
  };
  // } else {
  //   query = {
  //     mutation: {
  //       assignProfileToDevice: {
  //         __args: {
  //           device: param.devices[0],
  //           profileId: param.profileId
  //         }
  //       }
  //     }
  //   }
  // }

  return handleQuery(query, RELEASE_API_URL)
}


export function unassignProfile(param) {
  const query = {
    mutation: {
      unassignProfile: {
        __args: param,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function unassignProfiles(param) {
  const query = {
    mutation: {
      unassignProfiles: {
        __args: param,
        ...BULK_ACTION,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function getReleaseQuery(args) {
  const query = {
    query: {
      releases: {
        __args: args,
        count: true,
        data: RELEASE_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function releaseProfile(payload) {
  const query = {
    mutation: {
      createRelease: {
        __args: {
          ...payload,
        },
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function requestSnapshot(payload) {
  const query = {
    mutation: {
      requestUploadSnapshot: {
        __args: {
          ...payload,
        },
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function getImageUrl(payload) {
  const query = {
    query: {
      snapshotImageUrl: {
        __args: {
          ...payload,
        },
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function pushDeviceUpdate(payload) {
  const query = {
    mutation: {
      pushUpdate: {
        __args: {
          ...payload,
        },
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function getProfile(id) {
  const query = {
    query: {
      profileDetail: {
        __args: {
          id,
        },
        ...PROFILE_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function createProfile(param) {
  const query = {
    mutation: {
      createProfile: {
        __args: param,
        ...PROFILES_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function getProfiles(params) {
  const query = {
    query: {
      profiles: {
        __args: params,
        ...PROFILES_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function getProfileVersions(param) {
  const query = {
    query: {
      profileHistories: {
        __args: param,
        count: true,
        data: PROFILE_VERSION_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function getProfileVersion(data) {
  const query = {
    query: {
      profileHistories: {
        __args: data,
        count: true,
        data: PROFILE_VERSION_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}


export function archiveProfile(param) {
  const query = {
    mutation: {
      archiveProfile: {
        __args: param,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function archiveProfiles(param) {
  const query = {
    mutation: {
      archiveProfiles: {
        __args: param,
        ...BULK_ACTION,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function activateProfiles(param) {
  const query = {
    mutation: {
      unarchiveProfiles: {
        __args: param,
        ...BULK_ACTION,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function unarchiveProfile(param) {
  const query = {
    mutation: {
      unarchiveProfile: {
        __args: param,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function deleteProfile(param) {
  const query = {
    mutation: {
      deleteProfile: {
        __args: param,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function deleteProfiles(param) {
  const query = {
    mutation: {
      deleteProfiles: {
        __args: param,
        ...BULK_ACTION,
      },
    },
  };

  return handleQuery(query, RELEASE_API_URL)
}

export function updateProfile(param) {
  const query = {
    mutation: {
      updateProfile: {
        __args: param,
        ...PROFILES_RETURN_VALUES,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function rescanDeviceHealth(param) {
  const query = {
    mutation: {
      rescanDeviceHealth: {
        __args: param,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}

export function getCurrentDeploymentCount(args) {
  const query = {
    query: {
      currentDeploymentCount: {
        __args: args,
      },
    },
  };
  return handleQuery(query, RELEASE_API_URL)
}
